import React from 'react';
import { List, TextField, DateField } from 'react-admin';

import CustomDatagrid from '~components/CustomDatagrid';

const dateFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: '2-digit',
  hour: '2-digit',
  minute: '2-digit'
};

function AccionBorradorList(props) {
  return (
    <List {...props} bulkActionButtons={false} perPage={50}>
      <CustomDatagrid rowClick="edit">
        <TextField source="code" label="Código" sortable={false} />
        <TextField source="name" label="Nombre" sortable={false} />
        <DateField source="updatedAt" label="Última modificación" showTime locales={'es-AR'} options={dateFormatOptions} sortable={false} />
      </CustomDatagrid>
    </List>
  );
}

export default AccionBorradorList;
